import * as OrdersPayloadType   from 'shared/types/OrdersPayload';
import * as OrdersType          from 'Dispatcher/components/Orders';

interface Props extends OrdersType.Props {
}

export default class UnassignedOrders extends OrdersType.Orders<Props> {
    protected fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise<OrdersPayloadType.Dehydrated<number>>(
            '/api/dispatcher/orders/assigned',
            'GET',
            undefined,
            {orderby,limit,skip}
        ).then(OrdersPayloadType.hydrate);
    }
}
